import { Button, Text } from '@user-portal/wikr-components';
import { trackStartSurvey } from 'analytics/trackers/login';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { isEmpty } from 'helpers/utils';

import FormikInput from 'components/FormikInput';
import { EmailIcon } from 'components/Icon';

import appConfig from 'appConfig';

import * as S from './styled';

interface EmailFormProps {
    handleSubmit: () => void;
    setFieldTouched: (field: string) => void;
    initialValues: Record<string, any>;
    setFieldValue: (field: string, value: any) => void;
    touched: Record<string, boolean>;
    values: Record<string, any>;
    errors: Record<string, string>;
    dirty: boolean;
    isFetching: boolean;
}

export const EmailForm = ({
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    initialValues,
    isFetching,
    values,
    touched,
    errors,
    dirty,
}: EmailFormProps) => {
    const { t } = useTranslation();

    return (
        <S.Container>
            <Text type="h4" mb={12} center>
                {t('login.title')}
            </Text>
            <Text color="text-secondary" center>
                {t('login.subTitle')}{' '}
            </Text>
            <Text mb={24} center>
                <a href={appConfig.links.onboarding} data-locator="surveyButton" onClick={trackStartSurvey}>
                    {t('login.survey')}
                </a>
            </Text>

            <S.Form onSubmit={handleSubmit}>
                <FormikInput
                    mb={52}
                    type="email"
                    field="email"
                    label="input.email.label"
                    setFieldTouched={setFieldTouched}
                    initialValues={initialValues}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    values={values}
                    errors={errors}
                    leftIcon={() => <EmailIcon />}
                    dataLocator="loginEmailInput"
                    placeholder="input.email.label"
                />
                <Button
                    disabled={!dirty || !isEmpty(errors) || isFetching}
                    isLoading={isFetching}
                    onClick={handleSubmit}
                    dataLocator="loginButton"
                >
                    {t('basics.login')}
                </Button>
            </S.Form>
        </S.Container>
    );
};
